var React = require('react');
var ReactDOM = require('react-dom');
var moment = require('moment');
import Calendar from './Calendar.jsx';
import { Provider } from 'react-redux';
import { compose, createStore, applyMiddleware, combineReducers } from 'redux';
import reducers from './reducers'
import { initialStates } from './reducers';
import { editComplete } from './actions';
import { priceInRange, priceBeforeDiscountInRange, firstAvailablePeriod } from './reducers/calendar';

var thunkMiddleware = require('redux-thunk').default

const convertDowToNumber = function(string) {
    const dows = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    return dows.indexOf(string);
}

function getCurrentLocale() {
    var locale = document.documentElement.lang.replace('-', '_');
    if (locale == 'ca_es') {
        locale = 'ca';
    }
    return locale;
}

var locale = getCurrentLocale();

moment.locale(locale);
moment.updateLocale(locale, { week : { dow : 1, doy: 6} ,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    }
});

export class CalendarContainer {
    constructor(selector, availabilityRanges, pricingRanges, numPeople, start, end, buttonTitle, buttonSubtitle, options, extrasIncludedPrice ) {
        options = _.defaults(options, {
            visible: true,
            type: 'desktop',
            currency: 'EUR',
            currencyRate: 1,
            bookingType: 'booking',
            confirmWithOwner: true,
            cleaningIncluded: false,
        });
        const startMoment = start == '' ? null: moment.utc(start);
        const endMoment = end == ''? null: moment.utc(end).clone().subtract(1, 'day');

        var losPricing = [];

        for (let [ key, value ]  of Object.entries(pricingRanges) ) {
            let ranges = _.map(value, (pr) => {
                return {
                    lengthOfStay: key,
                    discountEndsAt: (typeof pr.discountEndsAt != 'undefined') ? pr.discountEndsAt : null, 
                    start: moment.utc(pr.start),
                    end: moment.utc(pr.end),
                    price: parseFloat(pr.price),
                    arrivalDays: _.map(pr.arrivalDays, convertDowToNumber),
                    minimalStay: (pr.minimalStay) ? pr.minimalStay : 1,
                    priceWithDiscount: parseFloat(pr.priceWithDiscount),
                    buttonTitle: buttonTitle,
                    buttonSubtitle: buttonSubtitle,
                }
            });
            losPricing[key] = ranges;
        };
        const pricing = losPricing;

        const { calendarState } = initialStates;

        const ranges = {
            availability : _.map(availabilityRanges, (av) => {
                return {start: moment.utc(av.start), end: moment.utc(av.end)};
            }),
            pricing : pricing,
        };
        let lengthOfStay = (startMoment && endMoment) ? endMoment.diff(startMoment,'day') + 1 : 7;
        if (lengthOfStay > 7 ) {  lengthOfStay = 7 }
        const firstAvailableMoment = firstAvailablePeriod({startMoment, endMoment, ranges});
        const initialState = {
            calendarStore: _.extend(
                calendarState,
                {
                    lengthOfStay: lengthOfStay,
                    ranges: ranges,
                    year : firstAvailableMoment.year(),
                    firstMonth: firstAvailableMoment.month(),
                    buttonTitle: buttonTitle,
                    buttonSubtitle: buttonSubtitle,
                    visible: options.visible,
                    type: options.type,
                    bookingType: options.bookingType,
                    vertical : options.type != 'desktop',
                    numPeople: numPeople,
                    firstPeriodStart: startMoment,
                    firstPeriodEnd: endMoment,
                    firstPeriodPrice: startMoment && (priceInRange(startMoment, endMoment, pricing[lengthOfStay]) + extrasIncludedPrice),
                    firstPeriodPriceBeforeDiscount: startMoment && (priceBeforeDiscountInRange(startMoment, endMoment,  pricing[lengthOfStay]) + extrasIncludedPrice),
                    currency: options.currency,
                    currencyRate: options.currencyRate,
                    static: options.static,
                    interactive: options.interactive,
                    extrasIncludedPrice: extrasIncludedPrice,
                    confirmWithOwner: options.confirmWithOwner,
                    cleaningIncluded: options.cleaningIncluded,
                })
        }

        function createOnEditComplete(extraArgument) {
            return ({ dispatch, getState }) => next => action => {
                const prevState = getState();
                let result = next(action);
                if (action.type == 'DAY_CLICK') {
                    const nextState = getState();
                    if (prevState.calendarStore.inEdit == true &&
                        nextState.calendarStore.inEdit == false &&
                        nextState.calendarStore.type == 'mobile-booking'
                       ) {
                            dispatch(editComplete());
                    }
                }
                return result;
            };
        }
        const onEditComplete = createOnEditComplete();
        onEditComplete.withExtraArgument = createOnEditComplete;

        const reducer = combineReducers(reducers);
        const composedStore = compose(
            applyMiddleware(thunkMiddleware, onEditComplete)
        );
        const storeCreator = composedStore(createStore);
        const store = storeCreator(reducer, initialState);

        const renderCalendar = () => {
            switch (options.type) {
                case 'desktop' || 'desktop_static':
                    return <Calendar static={options.static} interactive={options.interactive} selector={selector}/>
                    break;
                case 'mobile-booking':
                    //return <CalendarMobile/>
                    return <Calendar />
                    break;
                case 'mobile-accommodation':
                    return <Calendar/>
                    break;
            }
        }

        ReactDOM.render(
            <Provider store={store}>
                {renderCalendar()}
            </Provider>,
            document.getElementById(selector)
        );
    }
}
